import React, { useEffect, useRef, useCallback } from 'react';
import './TrackRow.scss';
import MediaObject from './MediaObject';

export default function TrackRow({
  uri,
  title,
  subtitle,
  imageUrl = "data:image/svg+xml, %3Csvg className='TrackRow__artwork' width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath fill='%23BDBDBD' fillRule='evenodd' d='M28.5 25.159v10.899A3.485 3.485 0 0026 35c-1.93 0-3.5 1.57-3.5 3.5S24.07 42 26 42s3.5-1.57 3.5-3.5V25.969l11-2.339v10.178A3.485 3.485 0 0038 32.75c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5V22.395l-13 2.764zM26 41a2.503 2.503 0 01-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5S27.378 41 26 41zm12-2.25a2.503 2.503 0 01-2.5-2.5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.378-1.122 2.5-2.5 2.5z' clipRule='evenodd' /%3E%3C/svg%3E",
  isPlaying,
  isAdded,
  feedback,
  onClick,
  canPreview,
  onActionButtonClick,
  onToggleFeedbackState,
  onDemand,
  sortValue,
  shouldScrollIntoView,
  subtitleBadges,
  actionButton = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className="woho"
    >
      <path
        fill="#B3B3B3"
        d="M2 6.5a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 002 6.5zm6 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6 0a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 0014 6.5z"
      ></path>
    </svg>
  ),
  extraActionButton,
}) {
  const trackRowRef = useRef();

  useEffect(() => {
    if (shouldScrollIntoView) {
      setTimeout(
        () =>
          trackRowRef.current.scrollIntoView({
            block: 'center',
          }),
        0
      );
    }
  }, [uri, shouldScrollIntoView]);

  return (
    <div
      className={`TrackRow ${isPlaying ? 'TrackRow--is-playing' : ''} ${
        isAdded ? 'TrackRow--is-saved' : ''
      } ${feedback === 1 ? 'TrackRow--has-feedback' : ''} ${
        onDemand ? 'TrackRow--on-demand' : 'TrackRow--preview'
      } ${shouldScrollIntoView ? 'TrackRow--flash' : ''} ${
        sortValue != null ? 'TrackRow--has-sort-chip' : ''
      } ${extraActionButton ? 'TrackRow--has-extra-action-button' : ''}`}
      onClick={onClick}
      ref={shouldScrollIntoView ? trackRowRef : null}
    >
      {canPreview || !onDemand ? (
        <MediaObject
          uri={uri}
          imageUrl={imageUrl}
          className="TrackRow__artwork"
        />
      ) : (
        <div
          className="TrackRow__artwork"
          style={{
            backgroundImage: `url("${imageUrl}")`,
          }}
        />
      )}

      <div className="TrackRow__title no-wrap">{title}</div>
      <div className="TrackRow__subtitle no-wrap">
        {subtitleBadges} {subtitle}
      </div>

      {sortValue != null && <div className="TrackRow__chip">{sortValue}</div>}

      {!onDemand && (
        <svg
          className="TrackRow__subtitle-preview-label no-wrap"
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="12"
          fill="none"
          viewBox="0 0 44 12"
          style={{ display: 'inline-block' }}
        >
          <path
            fill="#B3B3B3"
            d="M0 2a2 2 0 012-2h40a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2V2z"
          ></path>
          <path
            fill="#121212"
            d="M4.064 5.526V3.699h.981c.621 0 1 .351 1 .918 0 .549-.379.909-1 .909h-.98zm1.134 1.071c1.26 0 2.097-.828 2.097-1.989 0-1.152-.837-1.989-2.097-1.989H2.813V9h1.242V6.597h1.143zM11.413 9h1.386L11.43 6.39c.837-.243 1.359-.918 1.359-1.809 0-1.107-.792-1.962-2.034-1.962H8.263V9h1.25V6.543h.649L11.412 9zm-1.9-3.528V3.699h1.009c.63 0 .999.351.999.891 0 .522-.37.882-1 .882H9.515zM17.929 9V7.83h-2.754V6.354h2.493V5.247h-2.493V3.789h2.754v-1.17h-3.996V9h3.996zm3.591-1.638l-1.664-4.743h-1.36L20.854 9h1.278l2.367-6.381h-1.314L21.52 7.362zM26.61 9V2.619h-1.26V9h1.26zm5.486 0V7.83h-2.753V6.354h2.492V5.247h-2.492V3.789h2.754v-1.17H28.1V9h3.995zm7.247-1.971l-1.422-4.41h-1.288L35.22 7.011l-1.17-4.392h-1.313L34.509 9h1.295l1.459-4.545L38.72 9h1.278l1.764-6.381h-1.27l-1.151 4.41z"
          ></path>
        </svg>
      )}

      {feedback == 1 && (
        <div
          className="TrackRow__right-feedback-wrapper"
          onClick={(event) => {
            event.stopPropagation();
            onToggleFeedbackState();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
          >
            <path
              fill="#1DB954"
              fillRule="evenodd"
              d="M12.198 3.999c.831 0 1.584.388 2.066 1.064.482.677.603 1.515.332 2.3l-1.647 4.962c-.399 1.157-1.612 1.979-2.826 1.979-.134 0-.268-.01-.402-.031L3 13.196V4.442L6.256.676a1.86 1.86 0 012.34-.4 1.675 1.675 0 01.694 2.136l-.71 1.587h3.618zM2 5H0v8h1.778l.222.036V5z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>
      )}

      {extraActionButton}

      {actionButton && (
        <div
          className="TrackRow__right-button-wrapper"
          onClick={(event) => {
            event.stopPropagation();
            if (onActionButtonClick) onActionButtonClick(event);
          }}
        >
          {actionButton}
        </div>
      )}
    </div>
  );
}
